import { X } from 'lucide-react' // Assuming you have an icon library like lucide-react
import React from 'react'

import { Option } from './MultiSelectDropdown'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './shadcn-ui'

interface DropdownProps {
  id?: string
  options: Option[]
  value: any
  onValueChange: (value: any) => void
  disabled?: boolean | false
  label?: string
  placeholder?: string
  isClearable?: boolean
}

const Dropdown: React.FC<DropdownProps> = ({
  id,
  options,
  value,
  onValueChange,
  disabled,
  label,
  placeholder = 'Select an option...',
  isClearable = false,
}) => {
  const handleClearSelection = () => {
    onValueChange(undefined)
  }

  const isValueEmpty = value === undefined || value === 0 || value === null || value === ''

  return (
    <div className="relative w-full">
      {
        label && (
          <label
            className="mb-1 block text-sm font-medium text-gray-700"
            htmlFor={id}
          >
            {label}
          </label>
        )
      }

      <Select
        disabled={disabled}
        value={isValueEmpty ? '' : value}
        onValueChange={onValueChange}
      >
        <SelectTrigger
          className="w-full"
          id={id}
        >
          <SelectValue placeholder={isValueEmpty ? placeholder : undefined} />
        </SelectTrigger>

        <SelectContent position="popper">
          {
            options.length === 0
              ? (
                  <p className="text-center text-sm leading-10 text-gray-600 dark:text-gray-400">
                    No results found.
                  </p>
                )
              : (
                  options.map(option => (
                    <SelectItem
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </SelectItem>
                  ))
                )
          }
        </SelectContent>
      </Select>

      {
        isClearable && !isValueEmpty && (
          <button
            className="absolute right-8 top-1/2 flex -translate-y-1/2 items-center justify-center text-gray-500 hover:text-gray-700"
            disabled={disabled}
            type="button"
            onClick={handleClearSelection}
          >
            <X className="size-4" />
          </button>
        )
      }
    </div>
  )
}

export default Dropdown
